export const PATH_TO_LOAD_ROBOTINT_SCRIPT = '/s_jq.js';
export const STAGE = 'stage';

export const TINT_SERVICE_ID_FOR_BASE_A_PAINT = '1824';
export const TINT_SERVICE_ID_FOR_BASE_C_PAINT = '5508';

export const TINT_SERVICE_IDS = [TINT_SERVICE_ID_FOR_BASE_A_PAINT, TINT_SERVICE_ID_FOR_BASE_C_PAINT];
